import { Chakra } from "@airhelp/react-ui-components";
import type { FormControlProps } from "..";

const { FormLabel, FormControl, Textarea: ChakraTextarea, FormHelperText } = Chakra;

const Textarea = ({
  errors,
  name,
  label,
  placeholder,
  register,
  disabled = false,
  helperText,
}: FormControlProps) => (
  <FormControl isInvalid={errors[name]} isDisabled={disabled} id={name}>
    <FormLabel htmlFor={name} fontWeight="semibold" mb={2}>
      {label}
    </FormLabel>
    <ChakraTextarea
      name={name}
      placeholder={placeholder}
      ref={register}
      mb={6}
      resize="none"
      rows={5}
    />
    {helperText && <FormHelperText color="greyscale.500">{helperText}</FormHelperText>}
  </FormControl>
);
export default Textarea;
